import { useState } from 'react'
import PrimaryButton from '../../global/components/buttons/primary-button/PrimaryButton'
import LocationDropDown from '../../global/components/location-drop-down/LocationDropDown'
import styles from './styles.module.css'
import { fetchData } from '../../global/utils/fetch'
import { reverseLocationConversion } from '../api'

interface ReversalResponse {
  message: string
  success: boolean
  locationName: string
  deleted: {
    schedulePatterns: number
    generatedDaySettings: number
  }
  preserved: {
    manualDaySettings: number
  }
}

export default function LocationConversionReverser() {
  const [form, setForm] = useState({
    locationObjectId: '',
  })
  const [loading, setLoading] = useState(false)

  async function onReverseClick() {
    const { locationObjectId } = form
    if (!locationObjectId) return alert('Please select a location')

    setLoading(true)
    try {
      const response = (await fetchData(
        reverseLocationConversion(locationObjectId),
      )) as ReversalResponse
      alert(`✅ Reversal complete! ${response.message}`)
      // setForm({ locationObjectId: '' })
    } catch (error: any) {
      console.error(error)
      alert(`❌ Reversal failed: ${error.message}`)
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className={styles.toolContainer}>
      <h2>Location Conversion Reverser</h2>
      <p className={styles.toolDescription}>
        🔄 Reverse DaySettings conversion back to WeekCalendar mode
      </p>

      <div className={styles.formContainer}>
        <LocationDropDown
          onLocationChange={(locationObjectId: string) =>
            setForm({ ...form, locationObjectId })
          }
          defaultValue={form.locationObjectId}
        />

        <div className={styles.buttonContainer}>
          <PrimaryButton
            buttonName={loading ? 'Reversing...' : 'Reverse Conversion'}
            onClick={onReverseClick}
            disabled={loading}
          />
        </div>
      </div>
    </div>
  )
}
